import { cn } from '@utils/cn';
import {
  type ComponentPropsWithRef,
  type ComponentRef,
  forwardRef,
} from 'react';

const Spinner = forwardRef<ComponentRef<'div'>, ComponentPropsWithRef<'div'>>(
  ({ className, ...props }, ref) => {
    return (
      <div
        className={cn(
          'size-3',
          'inline-block animate-spin border-[3px]',
          'rounded-full border-current border-t-transparent text-current',
          className,
        )}
        role="status"
        aria-label="Cargando"
        {...props}
        ref={ref}
      >
        <span className="sr-only">Cargando...</span>
      </div>
    );
  },
);

Spinner.displayName = 'Spinner';

export { Spinner };
